export default function Plus({ style }) {
  return (
    <svg
      className={style}
      width='15'
      height='15'
      viewBox='0 0 15 15'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M14.9427 8.96079H8.96079V14.9427H6.96681V8.96079H0.984863V6.96681H6.96681V0.984863H8.96079V6.96681H14.9427V8.96079Z'
        fill='white'
      />
    </svg>
  )
}